import {defineStore} from "pinia";
import {Source} from "@/domain/type/source.type.ts";
import SynchroApi from "@/api/synchro.api.ts";
import {computed, ref} from "vue";
import {CreateStatus} from "@/domain/type/create.type.ts";
import CompanyApi from "@/api/company.api.ts";
import createCompanyCreationService from "@/application/service/CompanyCreation.service.ts";


export const useCompanyCreateStore = defineStore("companyCreate", () => {
  const createStatus = ref<CreateStatus>(CreateStatus.none);
  const currentTarget = ref<Source>(Source.EVA);
  const mainTarget = ref<Source | undefined>(undefined);
  const manualForm = ref<boolean>(false);

  const service = createCompanyCreationService(
    {CompanyApi, SynchroApi},
    {
      getCurrentTarget: () => currentTarget.value,
      getMainTarget: () => mainTarget.value,
      setStatus: (s) => (createStatus.value = s),
      setManualForm: (v) => (manualForm.value = v),
    }
  );

  const statusIsError = computed(() =>
    [CreateStatus.error, CreateStatus.notExisting].includes(createStatus.value)
  );

  const createStatusText = computed(() => service.buildStatusMessage(createStatus.value, currentTarget.value));

  const loading = computed(() =>
    [
      CreateStatus.analyzing,
      CreateStatus.checkIfExistOnSirene,
      CreateStatus.checkIfExistOnTarget,
      CreateStatus.creating,
      CreateStatus.alreadyCreated,
      CreateStatus.redirection,
    ].includes(createStatus.value)
  );

  const createFromSiren = (siret: string) => service.createFromSiren(siret);
  const createManually = (siret: string, companyName: string) => service.createManually(siret, companyName);

  return {
    createFromSiren,
    createManually,
    createStatus,
    createStatusText,
    loading,
    currentTarget,
    mainTarget,
    statusIsError,
    manualForm,
  };
});
